import { useDisconnectConnectors } from '@/hooks/useDisconnectConnectors'
import { Button, ButtonProps } from './ui/Button'
import { useMutation } from '@tanstack/react-query'
import { cn } from '@/lib/utils'
import { useConnections } from 'wagmi'
import { testIdFactory } from '@/utils/test-id-factory.ts'

export function Disconnect({
	className,
	onDisconnect,
	variant = 'outline'
}: Pick<ButtonProps, 'className' | 'variant'> & { onDisconnect?: () => void }) {
	const disconnect = useDisconnectConnectors()
	const connections = useConnections()

	const { isPending, mutateAsync } = useMutation({
		mutationKey: ['disconnect'],
		mutationFn: disconnect
	})

	const onClick = async () => {
		await mutateAsync()
		onDisconnect?.()
	}

	return (
		<Button
			disabled={!connections.length}
			loading={isPending}
			onClick={onClick}
			variant={variant}
			className={cn('leading-none', className)}
			data-testid={testIdFactory.pepperDisconnectButton()}
		>
			Disconnect
		</Button>
	)
}
